import { FloorPlanStatusEnum } from '@api/enum';

export const getFloorPlanStatusLabel = (role: FloorPlanStatusEnum) => {
    const map = {
        ENABLED: 'ENABLED',
        DISABLED: 'DISABLED',
    };

    return map[role];
};

export const FloorPlanStatusLabel = [
    { label: getFloorPlanStatusLabel(FloorPlanStatusEnum.ENABLED), value: FloorPlanStatusEnum.ENABLED },
    { label: getFloorPlanStatusLabel(FloorPlanStatusEnum.DISABLED), value: FloorPlanStatusEnum.DISABLED },
];
